import styled from 'styled-components';

const AssociatedAssetClassParent = styled.div`
  .asset-block-parent {
    padding: 8px 0px;
    margin-bottom: 10px;
  }

  .asset-class-name {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: bold;
  }

  .asset-name-block {
    font-size: 14px;
    color: #2b22ff;
    font-weight: bold;
    cursor: pointer;
  }
`;

const AssetClassActionsPopover = styled.div`
  box-shadow: 1px 2px 25px rgba(0, 0, 0, 0.152945);
  border-radius: 8px;

  .action-block {
    padding: 8px 16px;
    cursor: pointer;
  }

  .action-name {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
  }

  .delete-action-name {
    font-size: 14px;
    color: #ea2632;
  }

  .action-block: hover {
    background-color: #e7efff;
  }
`;

export { AssociatedAssetClassParent, AssetClassActionsPopover };
